module.exports = __webpack_public_path__ + "static/img/samajuri (24).7201466.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/samajuri/samajuri (24).jpg
// module id = 4uuf
// module chunks = 0